import React from "react";
import {useTranslation} from "react-i18next";
import ListItem from "../../commons/ListItem";
import {addSearchQueryParam, removeSearchQueryParam} from "../../../redux/actions/common-search.actions";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import {useDispatch} from "react-redux";
import {EditionType} from "../../../types/publication";
import {SearchContext} from "../../../types/common-search";

const EditionTypeFilter = ({statusFilter: editionTypeFilter}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const handleChange = (value: string, checked: boolean) => {
        if (checked) {
            dispatch(addSearchQueryParam({
                ctx: SearchContext.PUBLICATION,
                field: 'editionTypeFilter',
                value: value
            }))
        } else {
            dispatch(removeSearchQueryParam({
                ctx: SearchContext.PUBLICATION,
                field: 'editionTypeFilter',
                value: value
            }))
        }
    }

    return (
        <ListItem label={t('publications.filters.editionType')}>
            <FormGroup row>
                <FormControlLabel
                    control={<Checkbox
                        onChange={(event, check) => handleChange(EditionType.STANDARD, check)}
                        checked={editionTypeFilter?.some((e) => e === EditionType.STANDARD)}
                    />}
                    label={t('enums.publications.editionType.' + EditionType.STANDARD)}
                />
            </FormGroup>
            <FormGroup row>
                <FormControlLabel
                    control={<Checkbox
                        onChange={(event, check) => handleChange(EditionType.SPECIAL_EDITION, check)}
                        checked={editionTypeFilter?.some((e) => e === EditionType.SPECIAL_EDITION)}
                    />}
                    label={t('enums.publications.editionType.' + EditionType.SPECIAL_EDITION)}
                />
            </FormGroup>
        </ListItem>
    )
}

export default EditionTypeFilter
